import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { t } from "@/i18n";

/**
 * Campo de contraseña con conmutador independiente para mostrar/ocultar.
 * 
 * Invariantes:
 * - Oculta por defecto (type="password").
 * - El botón es type="button" para no enviar el formulario accidentalmente.
 * - Conmutar no borra ni modifica el valor del campo.
 * - Nombre accesible con aria-label y title para tecnologías de asistencia.
 */
const PasswordInput = ({
  testId,
  "data-testid": dataTestId,
  toggleTestId,
  value,
  onChange,
  required = false,
  minLength,
  autoComplete,
  autoFocus = false,
  placeholder = "",
  className = "",
  name,
  disabled = false,
  id,
}) => {
  const [show, setShow] = useState(false);
  const effectiveTestId = testId || dataTestId;

  return (
    <div className="relative flex items-center">
      <input
        id={id}
        name={name}
        data-testid={effectiveTestId}
        type={show ? "text" : "password"}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`v-input pr-10 ${className}`}
      />
      <button
        type="button"
        data-testid={toggleTestId || (effectiveTestId ? `${effectiveTestId}-toggle` : "password-visibility-toggle")}
        onClick={() => setShow((prev) => !prev)}
        className="absolute right-2.5 flex h-7 w-7 items-center justify-center rounded text-[#737373] transition-colors hover:text-[#f4f1ec] focus:outline-none focus:ring-1 focus:ring-[#f5b544]"
        aria-label={show ? (t.auth?.hidePassword || "Ocultar contraseña") : (t.auth?.showPassword || "Mostrar contraseña")}
        title={show ? (t.auth?.hidePassword || "Ocultar contraseña") : (t.auth?.showPassword || "Mostrar contraseña")}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};

export { PasswordInput };
export default PasswordInput;
